// API configuration for connecting to backend
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// API endpoints
export const endpoints = {
  health: `${API_BASE_URL}/api/health`,
  auth: {
    login: `${API_BASE_URL}/api/auth/login`,
    register: `${API_BASE_URL}/api/auth/register`,
    logout: `${API_BASE_URL}/api/auth/logout`,
    changeEmail: `${API_BASE_URL}/api/auth/change-email`,
    deleteAccount: `${API_BASE_URL}/api/auth/account`,
  },
  therapists: {
    search: `${API_BASE_URL}/api/therapists/search`,
    create: `${API_BASE_URL}/api/therapists`,
    getById: (id) => `${API_BASE_URL}/api/therapists/${id}`,
    profile: `${API_BASE_URL}/api/therapists/profile`,
    me: `${API_BASE_URL}/api/therapists/me`,
  },
  admin: {
    stats: `${API_BASE_URL}/api/admin/dashboard/stats`,
    therapists: {
      pending: `${API_BASE_URL}/api/admin/therapists/pending`,
      all: `${API_BASE_URL}/api/admin/therapists/all`,
      approve: (id) => `${API_BASE_URL}/api/admin/therapists/${id}/approve`,
      reject: (id) => `${API_BASE_URL}/api/admin/therapists/${id}/reject`,
    }
  },
  search: {
    therapists: `${API_BASE_URL}/api/search/therapists`,
    suggestions: `${API_BASE_URL}/api/search/suggestions`,
    popular: `${API_BASE_URL}/api/search/popular`,
  },
  inquiries: {
    create: `${API_BASE_URL}/api/inquiries`,
  },
  upload: {
    profilePhoto: `${API_BASE_URL}/api/upload/profile-photo`,
    profileVideo: `${API_BASE_URL}/api/upload/profile-video`,
  }
};

// Default fetch configuration
export const apiConfig = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export default API_BASE_URL; 